import store from '@/store';

const getFileName = (name) => {
  const { state: { formData: { values } } } = store;
  if (values[name]) {
    return values[name].name;
  }
  return null;
};

export default getFileName;
